<div id="roles-popup" class="common-popup-block-doc control-de daterng">
    <form class="form" role="form"[formGroup]="roleForm" autocomplete="off">
        <div class="popoup-hearder">
            <h2 class="m-b-5" mat-dialog-title>Control de Accesos</h2>
        </div>
        <div class="popoup-content">
            <app-date-period-selector [IsBothDatesRequired]="true"
                                    [DateType]="DateFilterType.Common" [PeriodFrom]="getFormControl('DateFrom')"
                                    [PeriodTo]="getFormControl('DateTo')"
                                    (FromDateChanged)="setFilterValues('commonDateFrom', $event)"
                                    (ToDateChanged)="setFilterValues('commonDateTo', $event)"
                                    required-error-message="Se debe indicar el period"></app-date-period-selector>
        </div>
        <div class="popoup-footer">
            <button class="keep" (click)="submit()"> <span class="mat-button-wrapper">Descargar</span></button>
            <button class="cancel" (click)="cancel()"><span class="mat-button-wrapper">Cancelar</span></button>
        </div>
    </form>
</div>